import { Box, Button, Stack, TextField } from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import { useSnackbar } from "notistack";
import React from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import Loader3D from "../../../components/Loader/Loader3D";
import { courseCertificateIssuing, getBatchAdmissionRegister } from "../../../redux/features/batchSlice";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";

const certficateStatus = [
  { id: 0, name: "Not Issued" },
  { id: 1, name: "Issued" },
  { id: 2, name: "Not Applicable" },
];

const CourseCertificateLanding = ({ open, setOpen, dispatchParams, loading, courseEnrollmentId }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const initialValues = {
    certificate: "",
  };

  const schema = Yup.object({
    certificate: Yup.number().required("Certificate status is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = { courseEnrollmentId: courseEnrollmentId, certificate: values.certificate };
      dispatch(courseCertificateIssuing(data)).then((res) => {
        if (res.payload.status === "error") {
          enqueueSnackbar(res.payload.message, { variant: "error" });
        } else if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, { variant: "success" });
          dispatch(getBatchAdmissionRegister(dispatchParams));
          handleCancel();
        }
      });
    },
  });
  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };
  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth
      title={"Issuing Course Certificate"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      content={
        open ? (
          loading ? (
            <Loader3D />
          ) : (
            <>
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Box>
                    <Stack gap={2}>
                      <GlobalSelectField
                        options={{
                          formik,
                          name: "certificate",
                          label: "Course Certificate",
                          data: certficateStatus,
                          keys: {
                            id: "id",
                            value: "name",
                          },
                        }}
                      />
                    </Stack>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                    <Stack direction={"row"} spacing={1}>
                      <Button sx={{ boxShadow: "none" }} color="secondary" size="small" variant="contained" onClick={() => handleCancel()}>
                        Cancel
                      </Button>

                      <Button sx={{ boxShadow: "none" }} color="primary" size="small" variant="contained" type="submit">
                        {loading ? "Submiting..." : "Submit"}
                      </Button>
                    </Stack>
                  </Box>
                </Form>
              </FormikProvider>
            </>
          )
        ) : null
      }
    />
  );
};

export default CourseCertificateLanding;
